import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CheckoutVM } from '../../services/api';

@Component({
  selector: 'app-check-out',
  templateUrl: './check-out.component.html',
  styleUrls: ['./check-out.component.scss']
})
export class CheckOutComponent implements OnInit {
  model: CheckoutVM = <CheckoutVM>{};

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CheckOutComponent>  ) {
    
  }

  ngOnInit(): void {
    this.model.uuid = this.data.uuid;
  }

  checkout() {
    this.dialogRef.close(this.model);
  }

}
